import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Features from '../components/Features';
import HowItWorks from '../components/HowItWorks';
import Clients from '../components/Clients';
import Testimonials from '../components/Testimonials';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import RequestDemo from '../components/RequestDemo';

const Home = () => {
  return (
    <div className="home">
      <Header />
      <main>
        <Hero />
        <Features />
        <HowItWorks />
        {/* <Clients /> */}
        <Testimonials />
        <Contact />
        <RequestDemo />
      </main>
      <Footer />
    </div>
  );
};

export default Home;